export default __webpack_public_path__ + "static/media/SS2-min.994f50fb.png";